import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import inputprospectService from "services/prospect/inputprospectService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  prospectList: {},
  prospectItem: [],
};

export const getInputprospect = createAsyncThunk(
  "inputprospect/getInputprospect",
  async (data, { rejectWithValue }) => {
    try {
      const response = await inputprospectService.getInputprospect(data);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);
export const getInputprospectItem = createAsyncThunk(
  "inputprospect/getInputprospectItem",
  async (data, { rejectWithValue }) => {
    try {
      const response = await inputprospectService.getInputprospect(data);
      if (response) {
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const inputprospect = createSlice({
  name: "inputprospect",
  initialState,
  reducer: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    setProspectItem: (state, action) => {
      state.prospectItem = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder

      //get list Third Party Group
      .addCase(getInputprospect.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getInputprospect.fulfilled, (state, action) => {
        console.log("action.payload", action.payload);

        state.loading = false;
        state.prospectList = action.payload.data;
        state.getCount = action.payload.data.count;
      })
      .addCase(getInputprospect.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      })
      //get list Third Party Group
      .addCase(getInputprospectItem.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getInputprospectItem.fulfilled, (state, action) => {
        console.log("action.payload", action.payload);

        state.loading = false;
        state.prospectItem = action.payload.data;
        state.getCount = action.payload.data.count;
      })
      .addCase(getInputprospectItem.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        notification.error({
          message: "Data Not Found",
          description:
            "The data you are looking for is not available. Please check again.",
          duration: 3,
        });
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  inputprospect.actions;

export default inputprospect.reducer;
